module.exports = "<div class=\"bottom-group buttons\">\n\t<div class=\"button orange\" (click)=\"openDialog();\">{{ selected | translate}}</div>\n</div>\n"